var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.dataFrom.classificationId ? _vm.$t("编辑") : _vm.$t("新增"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("名称"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "sort",
      label: _vm.$t("排序"),
      hasFeedback: ""
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.dataFrom.sort,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "sort", $$v);
      },
      expression: "dataFrom.sort"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };